module.exports = __webpack_public_path__ + "media/grit3.727292f3.mp3";